// extracted by mini-css-extract-plugin
export var standaloneTable = "_h9-0";
export var standaloneTableWithBodyFill = "_h9-1";
export var withExtraHeader = "_h9-2";